import { Box, FormHelperText, Grid } from "@mui/material";
import SearchableSelect, {
  SelectOption,
} from "app/components/SearchableSelect";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectDepartmentOptions } from "store/global/fields/selector";
import { actions } from "store/global/fields/slice";
import { useStyles } from "../styles";
interface TProps {
  value: number;
  orgId: number;
  xs?: number;
  changeValue: (value: number) => void;
  disabled?: boolean;
  showAll?: boolean;
  error?: string;
  noReset?: boolean;
  isRequired?: boolean;
}
const DepartmentFiled = (props: TProps) => {
  const dispatch = useDispatch();
  const styles = useStyles();
  const List = useSelector(selectDepartmentOptions);

  const { t } = useTranslation();
  useEffect(() => {
    if (props.showAll) {
      if (!props?.noReset) {
        props.changeValue(0);
      }
      dispatch(actions.getDepartmentList({ id: props.orgId }));
      return;
    }
    if (props.orgId > 0 && props.showAll) {
      if (!props?.noReset) {
        props.changeValue(0);
      }
      dispatch(actions.getDepartmentList({ id: props.orgId }));
      return;
    }

    if (props.orgId > 0 && !props.showAll) {
      dispatch(actions.getDepartmentList({ id: props.orgId }));
      return;
    }

    dispatch(actions.getDepartmentListSuccess([]));

    return () => {};
  }, [props.orgId, props.showAll, props?.noReset]);

  const loading = List.loading;

  const hasError = !!props?.error;

  const options: SelectOption[] = List.items.map((item: any) => ({
    label: item.name,
    value: item.id,
    raw: item,
  }));

  return (
    <Grid item xs={props.xs ? props.xs : 2}>
      <label className={styles.label}>
        {t("TIMESLOT.DEPARTMENT_NAME")}
        {props.isRequired && <span style={{ color: "red" }}> *</span>}
      </label>
      <SearchableSelect
        options={options}
        value={props?.value?.toString() ?? ""}
        onChange={(val) => props.changeValue(Number(val))}
        disabled={props.disabled}
        loading={loading}
        searchable
        error={hasError}
        className={styles.textEnabled}
        showAllOption={
          props.showAll ? { label: t("COMMON.ALL"), value: 0 } : undefined
        }
      />
      <Box sx={{ display: "flex" }}>
        {hasError && <FormHelperText error>{props?.error}</FormHelperText>}
      </Box>
    </Grid>
  );
};
export default DepartmentFiled;
